import { render, staticRenderFns } from "./OrdersNext.vue?vue&type=template&id=611c4830&"
import script from "./OrdersNext.vue?vue&type=script&lang=js&"
export * from "./OrdersNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports